import type { TableCell } from './statement-table-reader';
import { normalizeCell, normalizeHeader, parseAmount } from './statement-value-utils';

export interface AmountColumnIndexes {
  amount: number | null;
  debit: number | null;
  credit: number | null;
}

export interface CurrencyColumnIndexes {
  currency: number | null;
  amount: number | null;
}

export function normalizeHeaders(row: TableCell[]): string[] {
  return row.map((cell) => normalizeHeader(normalizeCell(cell)));
}

export function findHeaderIndex(headers: string[], aliases: readonly string[]): number | null {
  const aliasSet = new Set(aliases.map(normalizeHeader));
  const index = headers.findIndex((header) => aliasSet.has(header));
  return index === -1 ? null : index;
}

export function resolveAmountFromColumns(row: TableCell[], indexes: AmountColumnIndexes): number | null {
  if (indexes.amount !== null) {
    return parseAmount(row[indexes.amount]);
  }

  const debit = indexes.debit === null ? null : parseAmount(row[indexes.debit]);
  const credit = indexes.credit === null ? null : parseAmount(row[indexes.credit]);

  if (debit && debit !== 0) {
    return -Math.abs(debit);
  }

  if (credit && credit !== 0) {
    return Math.abs(credit);
  }

  return null;
}

export function resolveCurrencyCodeFromColumns(row: TableCell[], indexes: CurrencyColumnIndexes): string | null {
  const fileCurrency = indexes.currency === null ? '' : normalizeCell(row[indexes.currency]).toUpperCase();
  if (fileCurrency) return fileCurrency;

  if (indexes.amount !== null) {
    const amountCell = normalizeCell(row[indexes.amount]);
    const match = amountCell.match(/\b([A-Z]{3})\s*$/);
    if (match) return match[1];
  }

  return null;
}
